import {PanelElement} from "../elements/PanelElement";

export class PaymentPanel extends PanelElement {
    isFlowSuccess() {
        return this.paymentRequestStatus && this.paymentRequestStatus.response != null;
    }
}
